import axiosInstance from "src/common/axiosInstance";

const webhookService = {
  show(phoneNumberId) {
    return axiosInstance.get(
      `/phone-numbers/${phoneNumberId}/webhook`
    );
  },

  create(phoneNumberId, data) {
    return axiosInstance.post(
      `/phone-numbers/${phoneNumberId}/webhook`,
      data
    );
  },

  update(phoneNumberId, data) {
    return axiosInstance.put(
      `/phone-numbers/${phoneNumberId}/webhook`,
      data
    );
  },

  destroy(phoneNumberId) {
    return axiosInstance.delete(
      `/phone-numbers/${phoneNumberId}/webhook`
    );
  },
};

export default webhookService;